import { render, staticRenderFns } from "./FormControlModulestructureCategoryComponentId.vue?vue&type=template&id=2b565328"
import script from "./FormControlModulestructureCategoryComponentId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureCategoryComponentId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports